import axios from "axios";
import { createStandaloneToast } from "@chakra-ui/react";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";
const { toast } = createStandaloneToast();

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add response interceptor to handle session expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check if it's a 401 error specifically due to token expiration
    if (
      error.response?.status === 401 &&
      (error.response?.data?.message === "Token expired" ||
        error.response?.data?.message === "Invalid token" ||
        error.response?.data?.message === "Unauthorized")
    ) {
      // Show toast notification
      toast({
        title: "Session Expired",
        description: "Your session has expired. Please log in again.",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "top",
      });

      // Clear token and reload page to trigger login
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);
